import { ChangeDetectionStrategy, Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { AuctionsFacade } from '@galabid/gb-dashboard/auctions/data-access'
import * as AuctionsActions from 'libs/gb-dashboard/auctions/data-access/src/lib/+state/auctions.actions'

interface CampaignPreview {
  name: string
  url_name: string
}

@Component({
  selector: 'gb-user-accounts-campaign-preview.component',
  standalone: false,
  templateUrl: './gb-user-accounts-campaign-preview.component.html',
  styleUrl: './gb-user-accounts-campaign-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbUserAccountsCampaignPreviewComponent {
  get campaigns(): CampaignPreview[] {
    return this.data.campaigns
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: { campaigns: CampaignPreview[] },
    private auctionsFacade: AuctionsFacade,
  ) {}

  goToCampaign(urlName: string, event: MouseEvent) {
    this.auctionsFacade.dispatch(AuctionsActions.goToAuction({ urlName, newTab: event.metaKey }))
  }
}
